import { DocumentNode, gql } from '@apollo/client';
import { Button, ButtonProps } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { useEventEditPermissions } from '@/imports/ui/pages/events/hooks/useEventEditPermissions';

import { EventControlsMenu_EventFragment } from './graphql-types/EventControlsMenu_EventFragment';

export const EventControlsMenu: React.FC<{
  event: EventControlsMenu_EventFragment;
}> & {
  eventFragment: DocumentNode;
} = ({ event, ...props }) => {
  const { eventEditHref } = useEventEditPermissions({
    event: event ?? undefined,
  });

  if (!eventEditHref) {
    return null;
  }

  return (
    <NextLink href={eventEditHref}>
      <Button size="sm" variant="outline" colorScheme="gray">
        Edit
      </Button>
    </NextLink>
  );
};
EventControlsMenu.eventFragment = gql`
  fragment EventControlsMenu_EventFragment on EventV2 {
    _id
    ...useEventEditPermissions_EventFragment
  }
  ${useEventEditPermissions.eventFragment}
`;
